import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InboundIpAddresses from '../../_snippets/inbound-ip-addresses.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Postgres connector can link your database tables to PostHog.`}</p>
    <p>{`To link Postgres:`}</p>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`Data pipeline page`}</a>{` and the sources tab in PostHog`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`New source`}</strong>{` and select Postgres`}</li>
      <li parentName="ol">{`Enter your database connection details:`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`Host:`}</strong>{` The hostname or IP your database server like `}<inlineCode parentName="li">{`db.example.com`}</inlineCode>{` or `}<inlineCode parentName="li">{`123.132.1.100`}</inlineCode>{`.`}</li>
          <li parentName="ul"><strong parentName="li">{`Port:`}</strong>{` The port your database server is listening to. The default is `}<inlineCode parentName="li">{`5432`}</inlineCode>{`.`}</li>
          <li parentName="ul"><strong parentName="li">{`Database:`}</strong>{` The name of the database you want like `}<inlineCode parentName="li">{`analytics_db`}</inlineCode>{`.`}</li>
          <li parentName="ul"><strong parentName="li">{`User:`}</strong>{` The username with the necessary permissions to access the database.`}</li>
          <li parentName="ul"><strong parentName="li">{`Password:`}</strong>{` The password for the user.`}</li>
          <li parentName="ul"><strong parentName="li">{`Schema:`}</strong>{` The schema for your database where your tables are located. The default is `}<inlineCode parentName="li">{`public`}</inlineCode>{`.`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Link`}</strong></li>
    </ol>
    <p>{`The data warehouse then starts syncing your Postgres data. You can see details and progress in the `}<a parentName="p" {...{
        "href": "https://us.posthog.com/pipeline/sources"
      }}>{`sources tab`}</a>{`.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Looking for an example of the Postgres source?`}</strong>{` Check out our tutorial where we `}<a parentName="p" {...{
          "href": "/tutorials/supabase-query"
        }}>{`connect and query Supabase data`}</a>{`.`}</p>
    </blockquote>

    <InboundIpAddresses mdxType="InboundIpAddresses" />
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` We currently don't support connections using IPv6, therefore, you may need to enable IPv4 connections to your database. This is required for Supabase, for example.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      